import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.EmailToSupplierForm', {
    formTitle: 'Email to Supplier',
    toggleLabel: 'Automatically email approved Purchase Order',
    toLabel: 'To',
    toPlaceholder: 'Enter email',
    toPlaceholderEmptyList: 'Type in a valid email address and press Enter',
    ccLabel: 'CC',
    ccPlaceholder: 'Enter email',
    ccPlaceholderEmptyList: 'Type in a valid email address and press Enter',
    fromLabel: 'From',
    replyToLabel: 'Reply to',
    subjectLabel: 'Subject',
    subjectPlaceholder: 'Enter subject',
    bodyLabel: 'Body',
    bodyPlaceholder: 'Enter text',
    attachmentsLabel: 'Attachments to supplier',
    sectionNote: 'This feature is restricted during trial.',
});
